/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getOneDirectionForAllDefinitionsEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getOneDirectionForAllDefinitions',
  auth: 'app',
  fingerprint: '9muD1ifv3hCEJQPayU9qt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false
};
export const getDefinitionsFromObjectTypeEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getDefinitionsFromObjectType',
  auth: 'app',
  fingerprint: '_IujAkdkQhSEJQPayU9qt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false
};
export const getAllBaseUnlabeledDefinitionsEarlyRequestRpc = {
  serviceName: 'com.hubspot.association.definitions.rpc.AssociationDefinitionsRpc',
  rpcName: 'getAllBaseUnlabeledDefinitions',
  auth: 'app',
  fingerprint: 'kkZkC1SFge2EJQPayU9qt5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false
};